"use strict";
// no scrolling with menu
window.addEventListener("hashchange", function() {
    if (window.location.hash === "#menu") document.body.classList.add("page__body--with-menu");
    else document.body.classList.remove("page__body--with-menu");
});
// page do not refresh after submitting form
var form = document.getElementById("formId");
function submitForm(event) {
    event.preventDefault();
    // eslint-disable-next-line
    alert("\u0414\u044F\u043A\u0443\u0454\u043C\u043E \u0437\u0430 \u0434\u043E\u0432\u0456\u0440\u0443)");
    form.reset();
}
form.addEventListener("submit", submitForm);

//# sourceMappingURL=index.32ad9972.js.map
